/**
 * 
 * key
 * 
 */


const key = 'bXljbGllbnR2aWRlbw=='

export default key 